import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=3adf6e39&scoped=true&"
import script from "./AlertHistory.vue?vue&type=script&lang=js&"
export * from "./AlertHistory.vue?vue&type=script&lang=js&"
import style0 from "./AlertHistory.vue?vue&type=style&index=0&id=3adf6e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf6e39",
  null
  
)

export default component.exports